import React from "react";
import { useCurrencyFormatter } from "../../hooks/useCurrencyFormatter";
import { MetricComponentProps } from "../../types/metrics";
import MetricItem from "./MetricItem";
import {
  formatPrincipal,
  formatInterestRate,
  formatMonthlyPayment,
  getMonthlyPaymentTooltip,
} from "./metricHelpers";

export default function TermLengthSecondaryMetric({
  sim,
}: MetricComponentProps) {
  const c = useCurrencyFormatter();

  return (
    <>
      <MetricItem value={formatPrincipal(sim, c)} tooltip="Principal Amount" />
      {" • "}
      <MetricItem
        value={formatInterestRate(sim)}
        tooltip="Mortgage Interest Rate"
      />
      {" • "}
      <MetricItem
        value={formatMonthlyPayment(sim, c)}
        tooltip={getMonthlyPaymentTooltip(sim)}
      />
    </>
  );
}
